var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "layout" }, [
    _c("div", { staticClass: "layout__header" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "layout__controls" }, [
        _c("div", { staticClass: "form-inline" }, [
          _c(
            "button",
            {
              staticClass: "btn-info btn--bigger",
              on: { click: _vm.consultar }
            },
            [
              _c("i", { staticClass: "fa fa-search" }),
              _c("span", [_vm._v("Consultar")])
            ]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn-success btn--bigger",
              on: { click: _vm.exportar }
            },
            [
              _c("i", { staticClass: "fa fa-file-excel-o" }),
              _c("span", [_vm._v("Exportar")])
            ]
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "card" }, [
      _vm._m(1),
      _vm._v(" "),
      _c("div", { staticClass: "card__content" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-xs-12 col-md-4" }, [
            _c(
              "div",
              {
                staticClass: "form-field select2",
                class: {
                  "select2--disabled": _vm.bodegas.length == 1
                }
              },
              [
                _c(
                  "div",
                  { staticClass: "select2-field" },
                  [
                    _c("v-select", {
                      attrs: {
                        options: _vm.bodegas,
                        label: "descripcion",
                        placeholder: "Seleccione..."
                      },
                      on: { input: _vm.inputBodega },
                      model: {
                        value: _vm.selectedBodega,
                        callback: function($$v) {
                          _vm.selectedBodega = $$v
                        },
                        expression: "selectedBodega"
                      }
                    }),
                    _vm._v(" "),
                    _c("label", { attrs: { for: "bodegas" } }, [
                      _vm._v("Sucursal")
                    ])
                  ],
                  1
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-xs-12 col-md-4" }, [
            _c("div", { staticClass: "form-field select2" }, [
              _c(
                "div",
                { staticClass: "select2-field" },
                [
                  _c("v-select", {
                    attrs: {
                      placeholder: "Seleccione...",
                      id: "supervisor_id",
                      options: _vm.recaudadores,
                      multiple: "",
                      label: "nombre"
                    },
                    on: {
                      input: _vm.inputRecaudadores,
                      search: _vm.searchRecaudadores
                    },
                    model: {
                      value: _vm.selectedRecaudadores,
                      callback: function($$v) {
                        _vm.selectedRecaudadores = $$v
                      },
                      expression: "selectedRecaudadores"
                    }
                  }),
                  _vm._v(" "),
                  _c("label", { attrs: { for: "supervisor_id" } }, [
                    _vm._v("Persona")
                  ])
                ],
                1
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-xs-12 col-md-4" }, [
            _c("div", { staticClass: "form-field select" }, [
              _c("div", { staticClass: "select-field" }, [
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.tipo,
                        expression: "form.tipo"
                      }
                    ],
                    attrs: { name: "tipo", id: "tipo" },
                    on: {
                      change: function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.$set(
                          _vm.form,
                          "tipo",
                          $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        )
                      }
                    }
                  },
                  [
                    _c("option", { attrs: { value: "T" } }, [_vm._v("Todos")]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "P" } }, [
                      _vm._v("Pagados")
                    ]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "N" } }, [
                      _vm._v("Pendientes")
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("label", { attrs: { for: "tipo" } }, [_vm._v("Tipo")])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-xs-12 col-md-4" }, [
            _c("div", { staticClass: "form-field select" }, [
              _c("div", { staticClass: "select-field" }, [
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.tipo_fecha,
                        expression: "form.tipo_fecha"
                      }
                    ],
                    attrs: { name: "tipo_fecha", id: "tipo_fecha" },
                    on: {
                      change: function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.$set(
                          _vm.form,
                          "tipo_fecha",
                          $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        )
                      }
                    }
                  },
                  [
                    _c("option", { attrs: { value: "H" } }, [_vm._v("Hoy")]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "A" } }, [_vm._v("Ayer")]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "P" } }, [
                      _vm._v("Personalizada")
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("label", { attrs: { for: "fecha" } }, [_vm._v("Fecha")])
              ])
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.form.tipo_fecha === "P",
                  expression: "form.tipo_fecha === 'P'"
                }
              ],
              staticClass: "col-xs-12 col-md-4"
            },
            [
              _c("div", { staticClass: "form-field" }, [
                _c(
                  "div",
                  { staticClass: "datepicker-field" },
                  [
                    _c("VueCtkDateTimePicker", {
                      attrs: {
                        id: "desde",
                        locale: "es",
                        "only-date": "",
                        "no-label": "",
                        "button-now-translation": "Ahora",
                        format: "YYYY-MM-DD",
                        formatted: "YYYY-MM-DD",
                        label: "Seleccione fecha..."
                      },
                      model: {
                        value: _vm.form.desde,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "desde", $$v)
                        },
                        expression: "form.desde"
                      }
                    }),
                    _vm._v(" "),
                    _c("label", [_vm._v("Desde")])
                  ],
                  1
                )
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.form.tipo_fecha === "P",
                  expression: "form.tipo_fecha === 'P'"
                }
              ],
              staticClass: "col-xs-12 col-md-4"
            },
            [
              _c("div", { staticClass: "form-field" }, [
                _c(
                  "div",
                  { staticClass: "datepicker-field" },
                  [
                    _c("VueCtkDateTimePicker", {
                      attrs: {
                        id: "hasta",
                        locale: "es",
                        "only-date": "",
                        "no-label": "",
                        "button-now-translation": "Ahora",
                        format: "YYYY-MM-DD",
                        formatted: "YYYY-MM-DD",
                        label: "Seleccione fecha..."
                      },
                      model: {
                        value: _vm.form.hasta,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "hasta", $$v)
                        },
                        expression: "form.hasta"
                      }
                    }),
                    _vm._v(" "),
                    _c("label", [_vm._v("Hasta")])
                  ],
                  1
                )
              ])
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "col-xs-12 col-md-4" }, [
            _c("div", { staticClass: "form-inline" }, [
              _c("label", { attrs: { for: "descuentos" } }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.tipo_movimiento,
                      expression: "form.tipo_movimiento"
                    }
                  ],
                  attrs: {
                    type: "radio",
                    name: "tipo_movimiento",
                    id: "descuentos",
                    value: "G"
                  },
                  domProps: { checked: _vm._q(_vm.form.tipo_movimiento, "G") },
                  on: {
                    change: [
                      function($event) {
                        return _vm.$set(_vm.form, "tipo_movimiento", "G")
                      },
                      _vm.consultar
                    ]
                  }
                }),
                _c("span", [_vm._v("Descuentos")])
              ]),
              _vm._v(" "),
              _c("label", { attrs: { for: "ingresos" } }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.tipo_movimiento,
                      expression: "form.tipo_movimiento"
                    }
                  ],
                  attrs: {
                    type: "radio",
                    name: "tipo_movimiento",
                    id: "ingresos",
                    value: "I"
                  },
                  domProps: { checked: _vm._q(_vm.form.tipo_movimiento, "I") },
                  on: {
                    change: [
                      function($event) {
                        return _vm.$set(_vm.form, "tipo_movimiento", "I")
                      },
                      _vm.consultar
                    ]
                  }
                }),
                _c("span", [_vm._v("Ingresos")])
              ])
            ])
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "card" }, [
      _vm._m(2),
      _vm._v(" "),
      _c("div", { staticClass: "card__content" }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-xs-12" },
            [
              _c("k-table", {
                ref: "movimientos",
                attrs: {
                  buscarButton: false,
                  filterStatus: false,
                  deleteButton: false,
                  createButton: false,
                  editButton: false,
                  params: _vm.form,
                  path: _vm.path,
                  columns: [
                    {
                      display: "Tipo de movimiento",
                      value: "tipo_movimiento.descripcion"
                    },
                    {
                      display: "Sucursal",
                      value: "bodega.descripcion"
                    },
                    {
                      display: "Fecha",
                      value: "fecha"
                    },
                    {
                      display: "Persona",
                      value: "persona.nombre"
                    },
                    {
                      display: "Detalle",
                      value: "detalle"
                    },
                    {
                      display: "Debe",
                      value: "valor",
                      numeric: true
                    },
                    {
                      display: "Descuento",
                      value: "descuento",
                      numeric: true
                    },
                    {
                      display: "Saldo",
                      value: "saldo",
                      numeric: true
                    },
                    {
                      display: "Creación",
                      value: "created_at"
                    }
                  ]
                }
              })
            ],
            1
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "card" }, [
      _vm._m(3),
      _vm._v(" "),
      _c("div", { staticClass: "card__content" }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-xs-12" },
            [
              _c("k-table", {
                ref: "movimientosCaja",
                attrs: {
                  buscarButton: false,
                  filterStatus: false,
                  deleteButton: false,
                  createButton: false,
                  editButton: false,
                  params: _vm.form,
                  path: _vm.pathCaja,
                  columns: [
                    {
                      display: "Tipo de movimiento",
                      value: "tipo_gasto.descripcion"
                    },
                    {
                      display: "Sucursal",
                      value: "bodega.descripcion"
                    },
                    {
                      display: "Fecha",
                      value: "fecha"
                    },
                    {
                      display: "Persona",
                      value: "persona.nombre"
                    },
                    {
                      display: "Detalle",
                      value: "detalle"
                    },
                    {
                      display: "Debe",
                      value: "valor",
                      numeric: true
                    },
                    {
                      display: "Creación",
                      value: "created_at"
                    }
                  ]
                }
              })
            ],
            1
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "layout__title" }, [
      _c("h3", [_vm._v("Reporte de Estado de Cuenta")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card__title" }, [
      _c("h5", [_vm._v("Información de la consulta")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card__title" }, [
      _c("h5", [_vm._v("Movimientos de Nómina")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card__title" }, [
      _c("h5", [_vm._v("Movimientos de caja")])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7abd2712", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7abd2712","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/nomina/ReporteEstadoCuenta.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-7abd2712","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/nomina/ReporteEstadoCuenta.vue
// module chunks = 0